import * as $ from 'jquery';
let test = {}
export function deepmerge(obj1, obj2, clearArrayFlg = false) {
  test = obj2
  if(clearArrayFlg){ clearArray(obj1, obj2); }
  return $.extend(true, {}, obj1, obj2);
}

function clearArray(obj1, obj2){
  if(obj1 == null){ return; }
  if(obj2 == null){ return; }
  if(obj1 instanceof Object){
    for(let x in obj1){
      if(Array.isArray(obj1[x]) && Array.isArray(obj2[x])){
        obj1[x] = undefined;
      }else if(obj1 instanceof Object){
        clearArray(obj1[x], obj2[x]);
      }
    }
  }
}
